import { HttpService } from 'core/modules/network-service';
import { get, isNil } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberCheckoutCostInformation defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberCheckoutCostInformationService } from 'services/memberCheckoutCostInformation';
 *
 * // create service instance and send/cancel request
 * const memberCheckoutCostInformationService = new MemberCheckoutCostInformationService();
 * const result = await memberCheckoutCostInformationService.fetchData( '<user-id>' ); // fetch data
 * memberCheckoutCostInformationService.cancel(); // cancel an active request
 */
export class MemberCheckoutCostInformationService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
            
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    costCalculation: get( response, 'body.component.data.state.costCalculation', {} ),
                    costSelection: isNil( get( response, 'body.component.data.state.costSelection', {} ) ) ? {} : get( response, 'body.component.data.state.costSelection', {} ),
                    flags: get( response, 'body.component.data.state.flags', {} ),
                    ... get( response, 'body.component.structure', {} )
                },
            };
            
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }


    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
